const Menu =  [
  { header: 'MENU' },
  {
    title: 'Perusahaan',
    group: 'MENU',
    icon: 'fas fa-building',
    // target: '_blank',
    name: 'Perusahaan',
  },
  {
    title: 'Gapoktan',
    group: 'MENU',
    icon: 'fas fa-users',
    // target: '_blank',
    name: 'Gapoktan',
  },
  {
    title: 'Pemerintah',
    group: 'MENU',
    icon: 'fas fa-briefcase',
    // target: '_blank',
    name: 'Pemerintah',
  },
  {
    title: 'Kontrak',
    group: 'MENU',
    icon: 'fas fa-file-contract',
    // target: '_blank',
    name: 'Kontrak',
  },
  {
    title: 'Pedagang Perantara',
    group: 'MENU',
    icon: 'fas fa-shipping-fast',
    // target: '_blank',
    name: 'PesananPengiriman',
  },
  {
    title: 'Pergerakan Barang',
    group: 'MENU',
    icon: 'fas fa-flag-checkered',
    // target: '_blank',
    name: 'PergerakanBarang',
  },
  {
    title: 'Feedback',
    group: 'MENU',
    icon: 'fas fa-comment',
    // target: '_blank',
    name: 'Feedback',
  },
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;
